export const handleDuration = (value: string | number) =>
  value !== "" && value != null ? Number(value) : undefined;
